import Tooltip from "@mui/material/Tooltip";
import ArrowBack from "@mui/icons-material/ArrowBack";
import watermindsLogo from "../../../assets/waterminds-full-logo.png";
import GenericForm from "common/Components/GenericForm/GenericForm";
import AuthPageFooter from "../AuthPageFooter";
import {
  StyledPage,
  StyledAuthMain,
  StyledContainer,
  StyledCard,
  StyledWatermindsLogo,
  StyledBackButton,
  StyledTitle,
  StyledForm,
  StyledErrorMessage,
  StyledSubmitButton,
  StyledSecondaryButton,
  StyledSuccessMessage,
} from "../AuthPageLayout.styles";
import { RESET_PASSWORD_UI } from "./confirmResetPassword.constants";
import { useConfirmResetPassword } from "./ConfirmResetPassword.hook";

export default function ConfirmResetPassword() {
  const {
    username,
    formValues,
    errors,
    bannerError,
    success,
    loading,
    resetFields,
    handleChange,
    handleBack,
    submit,
    navigate,
  } = useConfirmResetPassword();

  if (!username) {
    return (
      <StyledPage>
        <StyledAuthMain>
          <StyledContainer>
            <StyledCard>
              <StyledWatermindsLogo src={watermindsLogo} alt="Waterminds Logo" />
              <StyledTitle variant="h5" component="h2">
                {RESET_PASSWORD_UI.missingSessionTitle}
              </StyledTitle>
              <StyledErrorMessage component="p">
                {RESET_PASSWORD_UI.missingSessionMessage}
              </StyledErrorMessage>
              <StyledSecondaryButton
                variant="outlined"
                onClick={() => navigate("/")}
                fullWidth
              >
                {RESET_PASSWORD_UI.backToAppLabel}
              </StyledSecondaryButton>
            </StyledCard>
          </StyledContainer>
        </StyledAuthMain>
        <AuthPageFooter />
      </StyledPage>
    );
  }

  if (success) {
    return (
      <StyledPage>
        <StyledAuthMain>
          <StyledContainer>
            <StyledCard>
              <StyledWatermindsLogo src={watermindsLogo} alt="Waterminds Logo" />
              <StyledTitle variant="h5" component="h2">
                {RESET_PASSWORD_UI.successTitle}
              </StyledTitle>
              <StyledSuccessMessage>
                {RESET_PASSWORD_UI.successMessage}
              </StyledSuccessMessage>
            </StyledCard>
          </StyledContainer>
        </StyledAuthMain>
        <AuthPageFooter />
      </StyledPage>
    );
  }

  return (
    <StyledPage>
      <Tooltip title="Go back" placement="right">
        <StyledBackButton
          type="button"
          onClick={handleBack}
          disabled={loading}
          aria-label="Go back"
        >
          <ArrowBack />
        </StyledBackButton>
      </Tooltip>
      <StyledAuthMain>
        <StyledContainer>
          <StyledCard>
            <StyledWatermindsLogo src={watermindsLogo} alt="Waterminds Logo" />
            <StyledTitle variant="h5" component="h2">
              {RESET_PASSWORD_UI.title}
            </StyledTitle>
            <StyledForm noValidate onSubmit={submit}>
              <GenericForm
                fields={resetFields}
                values={formValues}
                onChange={handleChange}
                errors={errors}
                showBorder={false}
              />
              {bannerError ? (
                <StyledErrorMessage component="p">{bannerError}</StyledErrorMessage>
              ) : null}
              <StyledSubmitButton
                type="submit"
                variant="contained"
                disabled={loading}
                fullWidth
              >
                {loading
                  ? RESET_PASSWORD_UI.submittingLabel
                  : RESET_PASSWORD_UI.submitLabel}
              </StyledSubmitButton>
            </StyledForm>
          </StyledCard>
        </StyledContainer>
      </StyledAuthMain>
      <AuthPageFooter />
    </StyledPage>
  );
}
